const STRIPE_ACCOUNT_STATUSES = {
  ENABLED: 'ENABLED',
  REJECTED: 'REJECTED',
  COMPLETED: 'COMPLETED'
}

export { STRIPE_ACCOUNT_STATUSES }
